// noinspection ES6UnusedImports
import React, {Fragment} from 'react';

import {Link, Tooltip, Typography} from '@bonprix/design-system';
import Glossary from '../../helper/glossary';

export default function GlossaryEntry({label, entry, onGlossaryLabelClicked}) {
    const renderTooltipContent = (entry) => {
        const image = entry.imageResourceUrl ? (
            <div className="glossary-entry__image-wrapper">
                <img className="glossary-entry__image" src={entry.imageResourceUrl} />
            </div>
        ) : null;

        if (entry.links.length === 0) {
            return (
                <Typography variant="body1">
                    {<div dangerouslySetInnerHTML={{__html: entry.content}} />}
                    {image}
                </Typography>
            );
        }

        const linkEntries = entry.links.reduce((links, link) => ({...links, [link.text]: link}), {});
        const linkGlossary = Glossary.create({entries: linkEntries});
        const linksFoundInText = [];

        const linkRenderer = (linksFoundInText) => {
            return (label, link) => {
                linksFoundInText.push(link.url);
                return `<Link href=${link.url}>${link.text}</Link>`;
            };
        };

        const renderOtherLinks = (entry, linksFoundInText) => {
            const otherLinks = entry.links.filter((link) => !linksFoundInText.includes(link.url));
            return otherLinks.map(renderGlossaryEntryLink);
        };

        const renderGlossaryEntryLink = (link) => {
            return (
                <Link href={link.url}>
                    {link.text}
                </Link>
            );
        };

        const glossifiedContent = linkGlossary.glossify(
            entry.content,
            linkRenderer(linksFoundInText),
            (text) => `<span>${text}</span>`
        );

        return (
            <Typography variant="body1">
                <div dangerouslySetInnerHTML={{__html: glossifiedContent.join('')}} />
                {renderOtherLinks(entry, linksFoundInText)}
                {image}
            </Typography>
        );
    };

    return (
        <Tooltip content={renderTooltipContent(entry)} zIndex={1100}>
            <span onMouseOver={() => onGlossaryLabelClicked(label)}>
                {label}
            </span>
        </Tooltip>
    );
}
